import React from "react";

const Spinner = ({ size = 48, color = "#1976d2", style = {} }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      minHeight: size,
      ...style,
    }}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      style={{ display: "block" }}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke={color}
        strokeWidth="5"
        strokeDasharray="31.4 31.4"
        strokeLinecap="round"
        style={{
          transformOrigin: "center",
          animation: "spinner-rotate 1s linear infinite"
        }}
      />
      <style>{`
        @keyframes spinner-rotate {
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </svg>
  </div>
);

export default Spinner;
